import { ComponentProps, useMemo } from 'react';

import {
  EServiceTopBar,
  Navbar,
  NavbarHamburgerMenu,
  NavbarLinkList,
  NavbarMenuItemLink,
  NavbarPopoverMenu,
  useIsDeviceSize,
} from '@foradevelopment/fora-ui';

import { elementLinks, links, skipLink } from '../../router/links';
import { useTypedTranslation } from '../../i18n/i18n';

export const ResponsiveNavBar = ({ hasSelectedEmployer }: { hasSelectedEmployer: boolean }) => {
  const { t } = useTypedTranslation();
  const { isDesktop } = useIsDeviceSize();

  const eServiceText = t('header.eService');

  const allLinks = useMemo((): ComponentProps<typeof NavbarMenuItemLink>[] => {
    return [
      {
        to: links.markups,
        name: t('common.serviceNames.markups'),
        iconName: 'BindersIcon',
        description: t('common.serviceDescriptions.markups'),
      },
      {
        iconName: 'BillMiniIcon',
        name: t('common.serviceNames.invoices'),
        to: links.invoices,
        description: t('common.serviceDescriptions.invoices'),
      },

      {
        iconName: 'HandPointer',
        name: 'Manuell inmatning av löner',
        to: links.payroll,
        description: t('common.serviceDescriptions.manualReporting'),
      },
      {
        iconName: 'WorkerIcon',
        to: links.employments,
        name: t('common.serviceNames.employments'),
        description: t('common.serviceDescriptions.employments'),
      },
      {
        to: `${links.fileDashboard}#${elementLinks.fileUpload}`,
        iconName: 'UploadIcon',
        name: t('common.serviceNames.file'),
        description: t('common.serviceDescriptions.file'),
      },
    ];
  }, [t]);

  return !hasSelectedEmployer ? (
    <EServiceTopBar eServiceText={eServiceText} />
  ) : (
    <Navbar
      eServiceText={eServiceText}
      skipLink={{
        elementId: skipLink,
        skipToContentText: t('navigation.link.skipToMain'),
      }}
    >
      {isDesktop ? (
        <>
          <NavbarLinkList
            navbarLinks={[
              { to: links.fileDashboard, name: t('navigation.link.overview') },
              { to: links.payroll, name: 'Manuell inmatning av löner' },
              { to: links.employments, name: t('common.serviceNames.employments') },
            ]}
          />
          <NavbarPopoverMenu menuButton={{ name: t('navigation.link.subMenu') }}>
            {allLinks.map(NavbarMenuItemLink)}
          </NavbarPopoverMenu>
        </>
      ) : (
        <NavbarHamburgerMenu>
          <NavbarMenuItemLink
            name="Översikt - Rapportera löner för arbetare"
            to={links.fileDashboard}
            iconName="BellIcon"
          />
          {allLinks.map(NavbarMenuItemLink)}
        </NavbarHamburgerMenu>
      )}
    </Navbar>
  );
};
